import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppLayout } from "../../../layouts";
import { Header, NavAndTabs, Sides } from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import PersonalInformation from "./personalInformation";
import HealthMonitoring from "./healthMonitoring";
import HealthInformation from "./healthInformation";

const ProfilePage = ({ loginData }) => {
    const { t } = useTranslation();
    const { id } = useParams();

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(id || "personal-information");

    useEffect(() => {
        setActiveTab(id || "personal-information");
    }, [id]);
    const tabs = [
        {
            id: "personal-information",
            label: t("Personal") + " " + t("Information"),
            content: <PersonalInformation loginData={loginData} />,
            disabled: false,
        },
        {
            id: "health-information",
            label: t("patient_Details.health_information.health_information"),
            content: <HealthInformation loginData={loginData} />,
            disabled: false,
        },
        {
            id: "health-monitoring",
            label: t("patient_Details.health_monitoring.health_monitoring"),
            content: <HealthMonitoring loginData={loginData} />,
            disabled: false,
        },
    ];
    const onTabChange = (tabId) => {
        setActiveTab(tabId);

        if (tabId === "health-information") {
            navigate(`/patient/my-profile/health-information/health-tracking`);
        } else {
            navigate(`/patient/my-profile/${tabId}`);
        }
    };

    const currentTab = tabs.find((tab) => tab.id === activeTab);
    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage
                        pageHeading={`${t("Profile")} / ${currentTab?.label}`}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col>
                    <NavAndTabs.NavAndTabs
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={onTabChange}
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default ProfilePage;
